import { render, staticRenderFns } from "./PaymentLogo.vue?vue&type=template&id=488487a0"
import script from "./PaymentLogo.vue?vue&type=script&lang=js"
export * from "./PaymentLogo.vue?vue&type=script&lang=js"
import style0 from "./PaymentLogo.vue?vue&type=style&index=0&id=488487a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports